import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Dealer } from '@polaris-customerweb/sharedcomponents.map';
import { find } from 'lodash-es';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { SetDealers } from 'src/app/components/dealer/dealer.actions';
import { selectDealers } from 'src/app/components/dealer/dealer.reducer';
import { AppState } from 'src/app/models/app-state';
import { DealerResource } from 'src/app/services/dealer-resource.service';

@Injectable({ providedIn: 'root' })
export class DealerService {
    private dealers: Dealer[];
    private hasFetchedDealers = false;

    constructor(
        private dealerResource: DealerResource,
        private store: Store<AppState>
    ) {
        store
            .pipe(select(selectDealers))
            .subscribe((dealers) => (this.dealers = dealers));
    }

    getNearbyDealers(
        lat: number,
        lng: number,
        radius: number,
        limit: number
    ): Observable<Dealer[]> {
        return this.dealerResource.getNearbyDealers(lat, lng, radius, limit);
    }

    getAllDealers$(): Observable<Dealer[]> {
        if (!this.hasFetchedDealers) {
            return this.dealerResource.getAllDealers().pipe(
                switchMap((dealers) => {
                    this.hasFetchedDealers = true;
                    this.store.dispatch(new SetDealers(dealers));

                    return this.store.pipe(select(selectDealers));
                })
            );
        }

        return this.store.pipe(select(selectDealers));
    }

    getDealerById(dealerId: string): Observable<Dealer> {
        if (this.dealers) {
            const dealer = this.getDealerByIdFromCache(dealerId);

            if (dealer) {
                return of(dealer);
            }
        }

        return this.dealerResource.getDealerById(dealerId);
    }

    getDealerByIdFromCache(dealerId: string): Dealer | undefined {
        if (this.dealers) {
            return find(this.dealers, { id: dealerId });
        } else {
            return undefined;
        }
    }
}
